/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GoogleCalendarLinkData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsGoogleCalendarLink: build.query<GoogleCalendarLinkData, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/calendar/google-link` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsGoogleCalendarLinkApi };
export const { useGetSettingsGoogleCalendarLinkQuery, useLazyGetSettingsGoogleCalendarLinkQuery } = injectedRtkApi;
